export default __webpack_public_path__ + "static/media/Maxvit-D-20000-eng.7329b459.jpg";